<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <portlet class="students_content_area">
            <template slot="footer">
              <div class="row justify-content-center pt-4 pb-4">
                <bootstrap-pagination
                  v-if="pageGetter.page_total > 1"
                  :total-page-number="pageGetter.page_total"
                  @number:updated="updateJobsPage"
                />
              </div>
            </template>
            <table-wrapper>
              <table-row>
                <table-heading :cols="2">
                  Date
                </table-heading>
                <table-heading :cols="5">
                  Title
                </table-heading>
                <table-heading :cols="5">
                  Company
                </table-heading>
              </table-row>
              <table-row
                v-for="job in jobsGetter"
                :key="job.job_id"
                programmatic-navigation
                @row:selected="selectedRow($event, job.job_id)"
              >
                <table-data :cols="2">
                  {{ job.job_published_at || new Date() | moment("YYYY/MM/DD") }}
                </table-data>
                <table-data :cols="5">
                  {{ job.job_title }}
                </table-data>
                <table-data :cols="5">
                  {{ job.job_enterprise_name }}
                </table-data>
              </table-row>
            </table-wrapper>
          </portlet>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BootstrapPagination from '~bootstrap/Pagination'
import Portlet from '~components/common/Portlet'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'JobOpeningZhContent',
  components: {
    BootstrapPagination,
    Portlet,
    TableWrapper,
    TableRow,
    TableHeading,
    TableData
  },
  computed: {
    ...mapGetters('pages/job-openings', [
      'jobsGetter',
      'pageGetter'
    ])
  },
  async created () {
    await this.getJobs()
  },
  methods: {
    selectedRow (e, id) {
      this.$router.push({ path: `/job-opening/en/${id}` })
    },
    ...mapActions('pages/job-openings', [
      'getJobs'
    ]),
    updateJobsPage (page) {
      this.getJobs(page)
    }
  }
}
</script>
